//-------------------------------------------------------------------------------------------------- Imports
import { Row, Col } from "antd";
import { StyleSheet } from "../../StyleSheet";
import ListComponent, { ListComponentData } from "../../components/ListComponent";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useCallback, useEffect, useState } from "react";
import { getShowMegan } from "../../methods/Methods";
import { getConfigurableServiceState } from "../../stores/slices/configurableServicesSlice";

//-------------------------------------------------------------------------------------------------- View
const TechnicalSupport = () => {
    const navigate = useNavigate();
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [showFAQ, setShowFAQ] = useState<boolean>(false);
    const confService = useSelector(getConfigurableServiceState);
    const canUpdateDataNetwork = confService.dataList.some(
        (service) => service.name.startsWith("DAF_ACTIVATION_MY_NETWORK") && service.enabled
    );
    // const [hasMyNetwork, setHasMyNetwork] = useState<boolean>(false);
    // const responseMyNetworkk = useSelector((state: any) => state.myNetwork);



    const getShow = useCallback(async () => {
        await getShowMegan(idCliente)
            .then((response) => {
                setShowFAQ(response.data.data[0].show);
            })
            .catch(() => {
                setShowFAQ(false);
            });
    }, [idCliente]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor);
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            getShow();
        }
    }, [idCliente, getShow]);

    // useEffect(() => {
    //     if (
    //         idCliente &&
    //         responseMyNetworkk &&
    //         responseMyNetworkk.clientId === idCliente &&
    //         responseMyNetworkk.status === true &&
    //         Array.isArray(responseMyNetworkk.data) &&
    //         responseMyNetworkk.data.length > 0
    //     ) {
    //         setHasMyNetwork(true);
    //     } else {
    //         setHasMyNetwork(false);
    //     }
    // }, [idCliente, responseMyNetworkk]);

    const updateDataNetworkItem = { title: "Mi Wi-Fi", subtitle: "" };

    const optionsArray: Array<ListComponentData> = [
        ...(showFAQ ? [{ title: "Preguntas Frecuentes", subtitle: "" }] : []),
        { title: "Diagnóstico Técnico", subtitle: "" },
        { title: "Lista de Canales de TV", subtitle: "" },
        { title: "Órdenes de Servicio", subtitle: "" },
        ...(canUpdateDataNetwork ? [updateDataNetworkItem] : []),
    ];

    const goToRoute = (element: ListComponentData) => {
        switch (element.title) {
            case "Preguntas Frecuentes":
                navigate('/technical-support/frequently-question')
                break;
            case "Diagnóstico Técnico":
                navigate('/technical-support/technical-diagnostics')
                break;
            case "Lista de Canales de TV":
                navigate('/technical-support/channel-list');
                break;
            case "Órdenes de Servicio":
                navigate('/technical-support/order-service')
                break;
            case "Mi Wi-Fi":
                navigate('/technical-support/my-network')
                break
            default:
                break;
        }
    };

    return (
        <SubDefaultLayout title={"Soporte Técnico"} >
            <Row style={styles.rowPrincipal}>
                <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                    <ListComponent
                        arrayList={optionsArray}
                        onPress={(option: ListComponentData) => goToRoute(option)}
                    />
                </Col>
            </Row>
        </SubDefaultLayout>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    rowPrincipal: {
        marginTop: 30,
        display: 'flex',
        justifyContent: 'center',
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default TechnicalSupport;
